let dataPage, dataProject, currentBreakpoint, scrollFrameRequested, isSafariBrowser;

function detectBreakpoint(width) {
	if (width < 600) {
		return 's';
	} else if (width < 1040) {
		return 't';
	} else {
		return 'd';
	}
}

document.addEventListener('DOMContentLoaded', () => {
	initializeTheme();

	// Config
	currentBreakpoint = detectBreakpoint(window.innerWidth);
	isSafariBrowser = isSafari();
	jQuery.adult.init();
	jQuery.initExitLinks();

	initializeLimitedTags();
});

window.addEventListener('load', () => {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
	dataPage = document.body.getAttribute('data-page');
	dataProject = document.body.getAttribute('data-project');

	jQuery.rotator.attach();
	jQuery.videoThumbnail.init();
	jQuery.countdown.init();
	jQuery.countdown.upcomingInit();
	jQuery.customValidation.init();

	// Initialize all components
	initializeAccordion();
	initializeDialogs();
	initializeDropdowns();
	initializeJoinBar();
	initializeLoadMore();
	initializeMarquee();
	initializePopups();
	initializeStatusMessages();

	initializeFormPostAjax();

	// Common
	initializeToggleClass('.js-toggle-button');

	// Initialize page specific JS
	if (dataPage === 'detail') {
		initializeDownload();

		if (dataProject === 'czechcasting') {
			initializeModelPhotosDownload();
		}
	}

	if (dataPage === 'members-profile') {
		initializeTabPanel();
	}

	if (dataPage === 'join') {
		initializeJoinTitleSwitch();
	}

	// Initialize project specific JS
	if (dataProject === 'czechcasting') {
		initializeImageSwitcher();
	}

	// Initialize breakpoint specific JS
	// TODO: JS support of CSS breakpoints for initializing only when necessary
	// temp mobile only
	if (currentBreakpoint === 's') {
		initializeScrollToSecond();
		initializeVideoAutoplay();
	}

	// temp tablet-
	if (currentBreakpoint === 's' || currentBreakpoint === 't') {
		initializeSideMenu();
	}

	// temp desktop only
	if (currentBreakpoint === 'd') {
		const searchContentPagesArray = [
			'members:login',
			'members:lost-password',
			'members:lost-password-reset',
			'join',
			'error:forbidden'
		];
		if (!searchContentPagesArray.includes(dataPage)) {
			initializeSearchReel();
		}
	}

	//initializeVideoSectionAutoplay();
	initializeVideoAutoplay();
	initializeOptimizedLazyLoading();

	if (!sessionStorage.getItem('sessionStarted') || sessionStorage.getItem('sessionStarted') === 'join') {
		sessionStorage.setItem('sessionStarted', dataPage);
	}
});

// Global functions
function debounce(fn, delay) {
	let timeoutID;
	return function (...args) {
		clearTimeout(timeoutID);
		timeoutID = setTimeout(() => {
			fn.apply(this, args);
		}, delay);
	};
}

const scrollHandler = debounce(() => {
	if (!scrollFrameRequested) {
		scrollFrameRequested = true;
		requestAnimationFrame(() => {
			updateActiveVideo();
			scrollFrameRequested = false;
		});
	}
}, 100);
window.addEventListener('scroll', scrollHandler, { passive: true });

function isSafari() {
	const { userAgentData } = navigator;

	// Use User-Agent Client Hints if available
	if (userAgentData) {
		return userAgentData.brands.some(brand => brand.brand === 'Safari');
	}

	// Fallback to userAgent string for older browsers
	const ua = navigator.userAgent.toLowerCase();
	const isSafari = ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android');

	return isSafari;
}

// Initialize functions
function initializeAccordion() {
	const accordions = document.querySelectorAll('.accordion');

	if (accordions.length === 0) {
		return;
	}

	accordions.forEach(accordion => {
		const trigger = accordion.querySelector('[data-accordion="trigger"]');
		const content = accordion.querySelector('[data-accordion="content"]');

		if (!(trigger && content)) {
			return;
		}

		// Get custom transition speed from data attribute, fallback to default 500ms
		const transitionSpeed = accordion.getAttribute('data-accordion-speed') || 500;

		content.style.overflow = 'hidden';
		content.style.transition = `height ${transitionSpeed}ms cubic-bezier(0.25, 0.1, 0.25, 1)`;

		// Ensure content is hidden initially, unless it has class "is-open"
		let isOpen = accordion.classList.contains('is-open');
		if (!isOpen) {
			content.style.height = '0px';
		}

		// Check if this accordion allows only one content to be opened
		const isOneOnly = accordion.classList.contains('accordion--one-only');

		// Set up click event listener on the trigger
		trigger.addEventListener('click', () => {
			// Read phase - gather all measurements first
			let isOpen = accordion.classList.contains('is-open');
			const contentHeight = content.scrollHeight;

			// Collect all measurements for sibling accordions if needed
			const siblingUpdates = [];
			if (isOneOnly && !isOpen) {
				accordion.parentNode.querySelectorAll('.accordion.is-open').forEach(openAccordion => {
					if (openAccordion !== accordion) {
						const openContent = openAccordion.querySelector('[data-accordion="content"]');
						siblingUpdates.push({
							accordion: openAccordion,
							content: openContent,
							height: openContent.scrollHeight
						});
					}
				});
			}

			// Write phase - apply all DOM changes
			requestAnimationFrame(() => {
				// Update sibling accordions first
				siblingUpdates.forEach(update => {
					update.content.style.height = `${update.height}px`;
					requestAnimationFrame(() => {
						update.content.style.height = '0px';
						update.accordion.classList.remove('is-open');
					});
				});

				// Then update the clicked accordion
				if (isOpen) {
					// Closing
					content.style.height = `${contentHeight}px`;
					requestAnimationFrame(() => {
						content.style.height = '0px';
					});
				} else {
					// Opening
					content.style.height = `${contentHeight}px`;
				}

				// Toggle class state
				accordion.classList.toggle('is-open');
			});
		});
	});
}

function initializeDialogs() {
	// Initialize header network listing
	initializeDialog({
		dialogId: 'header-network-listing',
		triggerSelector: '#show-header-network-listing',
		closeSelector: '.header__network-listing__close',
		onOpen: () => {
			window.GlobalState.setNetworkListingOpen(true);
		},
		onClose: () => {
			window.GlobalState.setNetworkListingOpen(false);
		}
	});

	// Initialize header search compact
	initializeDialog({
		dialogId: 'header-search-compact',
		triggerSelector: '.header-search-compact.button',
		onOpen: () => {
			window.GlobalState.setHeaderSearchOpen(true);
			setTimeout(() => {
				const searchInput = document.querySelector('#header-search-compact input[type="search"]');
				if (searchInput) {
					searchInput.focus();
				}
			}, 50);
		},
		onClose: () => {
			window.GlobalState.setHeaderSearchOpen(false);
		}
	});
}

// TODO: check/remove
function initializeDropdowns() {
	const dropdowns = document.querySelectorAll('.x-dropdown');
	if (!dropdowns.length) {
		return;
	}

	let activeDropdown = null;

	function handleClickOutside(event) {
		if (activeDropdown && !activeDropdown.contains(event.target)) {
			activeDropdown.classList.remove('open');
			document.removeEventListener('click', handleClickOutside);
			activeDropdown = null;
		}
	}

	dropdowns.forEach(dropdown => {
		dropdown.addEventListener('click', function (event) {
			event.stopPropagation();

			if (activeDropdown && activeDropdown !== dropdown) {
				activeDropdown.classList.remove('open');
			}

			dropdown.classList.toggle('open');
			if (dropdown.classList.contains('open')) {
				activeDropdown = dropdown;
				document.addEventListener('click', handleClickOutside);
			} else {
				activeDropdown = null;
				document.removeEventListener('click', handleClickOutside);
			}
		});
	});
}

function initializeDialog({ dialogId, triggerSelector, closeSelector, onOpen, onClose }) {
	const dialog = document.getElementById(dialogId);
	if (!dialog) return;

	const dialogTrigger = document.querySelector(triggerSelector);
	const dialogClose = closeSelector ? dialog.querySelector(closeSelector) : null;
	const video = dialog.querySelector('video') || false;

	let isAnimating = false;

	function handleAnimation() {
		if (!dialog.classList.contains('is-open')) {
			dialog.close();
		}
		dialog.removeEventListener('transitionend', handleAnimation);
		dialog.removeEventListener('animationend', handleAnimation);
		isAnimating = false;
	}

	function handleClickOutside(event) {
		if (dialog.open && !dialog.contains(event.target) && event.target !== dialogTrigger) {
			toggleDialog();
		}
	}

	function toggleDialog() {
		if (isAnimating) return;
		isAnimating = true;

		if (dialog.open) {
			dialog.classList.remove('is-open');
			if (dialogTrigger) dialogTrigger.classList.remove('is-open');
			dialog.addEventListener('transitionend', handleAnimation);
			document.removeEventListener('click', handleClickOutside);
			if (onClose) onClose();

			if (video && !video.paused) {
				video.pause();
			}
		} else {
			dialog.show();
			dialog.classList.add('is-open');
			if (dialogTrigger) dialogTrigger.classList.add('is-open');
			dialog.addEventListener('animationend', handleAnimation);
			document.addEventListener('click', handleClickOutside);
			if (onOpen) onOpen();

			if (video) {
				if (!video.src) {
					video.src = video.dataset.src;
					video.dataset.src = null;
				}

				try {
					const playPromise = video.play();
					if (playPromise !== undefined) {
						playPromise.catch(error => {
							// Handle autoplay being blocked
							console.error('Video playback failed:', error);
						});
					}
				} catch (e) {
					console.error('Error playing video:', e);
				}
			}
		}
	}

	if (dialogTrigger) {
		dialogTrigger.addEventListener('click', toggleDialog);
	}
	if (dialogClose) {
		dialogClose.addEventListener('click', toggleDialog);
	}
}

function initializeJoinBar() {
	const joinBarManager = document.querySelector('.join-bar-holder');

	if (!joinBarManager) {
		return;
	}

	const isJoinBarClosed = sessionStorage.getItem('joinBarClosed') === 'true';
	if (isJoinBarClosed) {
		joinBarManager.remove();
		return;
	}

	const joinBar = joinBarManager.querySelector('.join-bar');
	const joinBarClose = joinBarManager.querySelector('.join-bar__close');

	const joinBarPictureVideo = joinBarManager.querySelector('.join-bar__picture video');
	let videoSetup = { src: null, type: null };
	if (joinBarPictureVideo) {
		if (isSafariBrowser) {
			videoSetup.src = joinBarPictureVideo.getAttribute('data-src-mov');
			videoSetup.type = 'video/quicktime';
		} else {
			videoSetup.src = joinBarPictureVideo.getAttribute('data-src-webm');
			videoSetup.type = 'video/webm';
		}
		joinBarPictureVideo.removeAttribute('data-src-webm');
		joinBarPictureVideo.removeAttribute('data-src-mov');
	}

	const topIOHelper = joinBarManager.querySelector('.join-bar__io--top');
	const bottomIOHelper = joinBarManager.querySelector('.join-bar__io--bottom');

	let isTopIOHelperInViewport = false;
	let isBottomIOHelperInViewport = false;

	function handleVisibility() {
		const shouldShow = !isTopIOHelperInViewport && !isBottomIOHelperInViewport;
		joinBar.classList.toggle('visible', shouldShow);

		if (joinBarPictureVideo && joinBarPictureVideo.src) {
			if (shouldShow && joinBarPictureVideo.paused) {
				const playPromise = joinBarPictureVideo.play();
				if (playPromise !== undefined) {
					playPromise.catch(error => {
						console.log('Video play failed:', error);
					});
				}
			} else if (!shouldShow && !joinBarPictureVideo.paused) {
				joinBarPictureVideo.pause();
			}
		}
	}

	function handleIntersect(entries) {
		entries.forEach(entry => {
			if (entry.target === topIOHelper) {
				isTopIOHelperInViewport = entry.isIntersecting;
			} else if (entry.target === bottomIOHelper) {
				isBottomIOHelperInViewport = entry.isIntersecting;
			}

			if (joinBarPictureVideo && !joinBarPictureVideo.src && videoSetup.src) {
				joinBarPictureVideo.src = videoSetup.src;
				joinBarPictureVideo.load();
			}

			handleVisibility();
		});
	}

	const observerOptions = {
		root: null,
		rootMargin: '0px',
		threshold: 0
	};

	const intersectionObserver = new IntersectionObserver(handleIntersect, observerOptions);

	intersectionObserver.observe(topIOHelper);
	intersectionObserver.observe(bottomIOHelper);

	function removeJoinBar(e) {
		e.preventDefault();
		joinBar.classList.remove('visible');
		sessionStorage.setItem('joinBarClosed', 'true');
		joinBar.addEventListener('transitionend', () => {
			joinBarManager.remove();
		});
	}

	joinBarClose.addEventListener('click', removeJoinBar);
}

function initializeLoadMore() {
	const loadMoreButtons = document.querySelectorAll('.load_more_button');

	loadMoreButtons.forEach(loadMoreButton => {
		if (!loadMoreButton) {
			return;
		}

		const galleryListing = loadMoreButton.parentNode.parentNode.querySelector('.listing-grid');
		const pagination = document.getElementById('pagination');
		const buttonText = loadMoreButton.querySelector('.button-text');
		const spinner = loadMoreButton.querySelector('.spinner');
		let nextUrl = loadMoreButton.getAttribute('data-next-url');
		let page = loadMoreButton.getAttribute('data-page');
		let type = loadMoreButton.getAttribute('data-type');
		let excludesKeys = loadMoreButton.getAttribute('data-exclude');
		//loadMoreButton.removeAttribute('data-next-url'); // Remove the data attribute after retrieving the URL

		if (!nextUrl) {
			loadMoreButton.style.display = 'none';
		}

		loadMoreButton.addEventListener('click', handleLoadMoreClick);

		function handleLoadMoreClick(event) {
			event.preventDefault();
			showSpinner();
			loadMore();
		}

		async function loadMore() {
			try {
				nextUrl = buildCorrectUrl(nextUrl, page, excludesKeys, type);
				const response = await fetch(nextUrl);
				const videos = await response.text();

				galleryListing.insertAdjacentHTML('beforeend', videos);
				updateNextUrl();
				updateCurrentUrl();

				if (typeof $.rotator !== 'undefined' && typeof $.rotator.attach === 'function') {
					$.rotator.attach();
				}

				if (typeof $.videoThumbnail !== 'undefined' && typeof $.videoThumbnail.init === 'function') {
					$.videoThumbnail.init();
				}

				if (window.videoAutoplayUtils && typeof window.videoAutoplayUtils.observeNewThumbnails === 'function') {
					const newThumbs = galleryListing.querySelectorAll('img.vthumb:not([data-observed])');

					newThumbs.forEach(thumb => {
						thumb.setAttribute('data-observed', 'true');
					});

					window.videoAutoplayUtils.observeNewThumbnails(newThumbs);
				}

				jQuery.initExitLinks(); // Reinitialize exit link params
			} catch (error) {
				console.error('Failed to load more videos:', error);
			} finally {
				hideSpinner();
				updatePagination();
				switchColorPreferenceImages(document.documentElement.getAttribute('data-theme'));

				if (window.videoAutoplayUtils && typeof window.videoAutoplayUtils.observeNewThumbnails === 'function') {
					const newThumbs = galleryListing.querySelectorAll('[data-autoplay-item]:not([data-observed])');
					window.videoAutoplayUtils.observeNewThumbnails(newThumbs);
					newThumbs.forEach(thumb => {
						thumb.setAttribute('data-observed', 'true');
					});
				}
			}
		}

		function buildCorrectUrl(relativeUrl, page, excludesKeys, type) {
			const url = new URL(relativeUrl, window.location.origin);
			const params = new URLSearchParams(url.search);

			params.set('p', page);

			if (excludesKeys) {
				let keysArray = JSON.parse(excludesKeys);
				let keysString = keysArray.join('-');
				params.set('keys', keysString);
			}

			if (type) {
				params.set('type', type);
			}

			url.search = params.toString();

			return url.toString();
		}

		function showSpinner() {
			buttonText.style.display = 'none';
			spinner.style.display = 'initial';
		}

		function hideSpinner() {
			buttonText.style.display = 'initial';
			spinner.style.display = 'none';
		}

		function updateNextUrl() {
			const nextPages = document.querySelectorAll('.next-page');
			nextUrl = nextPages.length ? nextPages[nextPages.length - 1].getAttribute('data-url') : '';
			if (!nextUrl) {
				loadMoreButton.style.display = 'none';
			}
		}

		function updateCurrentUrl() {
			const currentPages = document.querySelectorAll('.current-page');
			let currentUrl = currentPages.length ? currentPages[currentPages.length - 1].getAttribute('data-url') : '';

			if (currentUrl) {
				const url = new URL(currentUrl, window.location.origin);
				url.searchParams.delete('keys');
				currentUrl = url.toString();

				if (!['detail', 'search'].includes(page)) {
					history.pushState(null, '', currentUrl);
				}
			}
		}

		function updatePagination() {
			if (pagination && pagination.hasAttribute('data-current')) {
				const currentPage = parseInt(pagination.getAttribute('data-current'), 10);
				const nextPage = currentPage + 1;
				const lastPage = parseInt(pagination.getAttribute('data-last'), 10);
				const activeItem = document.querySelector('.pagination__item--active');
				const previousButton = pagination.querySelector('.pagination__item--previous');
				const nextButton = pagination.querySelector('.pagination__item--next');

				pagination.setAttribute('data-current', nextPage);

				if (activeItem) {
					activeItem.classList.remove('pagination__item--active');

					const nextListItem = activeItem.parentElement.nextElementSibling;

					if (nextListItem) {
						const nextItem = nextListItem.querySelector('a.pagination__item');

						if (!nextItem) {
							hidePagination();
						}

						if (nextItem) {
							nextItem.classList.add('pagination__item--active');
						}
					}

					previousButton.style.display = 'none';
					nextButton.style.display = 'none';
				}
			}
		}

		function hidePagination() {
			pagination.style.display = 'none';
		}
	});
}

function initializeMarquee() {
	const marquees = document.querySelectorAll('.marquee');
	if (!marquees.length) return;

	const contentWidths = new Map();

	marquees.forEach(marquee => {
		const marqueeContent = marquee.querySelector('.marquee__content');
		if (!marqueeContent) return;

		const firstImage = marqueeContent.querySelector('img');

		// If no images, initialize immediately
		if (!firstImage) {
			initializeMarqueeContent(marquee, marqueeContent);
			return;
		}

		// Wait only for the first image
		if (firstImage.complete) {
			initializeMarqueeContent(marquee, marqueeContent);
		} else {
			firstImage.addEventListener('load', () => {
				initializeMarqueeContent(marquee, marqueeContent);
			});
			firstImage.addEventListener('error', () => {
				initializeMarqueeContent(marquee, marqueeContent);
			});
		}
	});

	function initializeMarqueeContent(marquee, marqueeContent) {
		contentWidths.set(marquee, marqueeContent.getBoundingClientRect().width);
		updateMarquee(marquee);
	}

	function updateMarquee(marquee) {
		const containerWidth = document.querySelector('.page-content').getBoundingClientRect().width;
		const contentWidth = contentWidths.get(marquee);

		if (contentWidth > containerWidth) {
			const marqueeContent = marquee.querySelector('.marquee__content');
			marqueeContent.querySelectorAll('img').forEach(img => {
				//console.log('removing lazy: ', img);
				img.removeAttribute('loading');
			});

			if (marquee.querySelectorAll('.marquee__content').length === 1) {
				const duplicateMarqueeContent = marqueeContent.cloneNode(true);
				marquee.appendChild(duplicateMarqueeContent);
			}
			marquee.classList.add('marquee--animate');
			marquee.classList.remove('marquee--static');

			const marqueeSpeed = Math.round(contentWidth / 25);
			marquee.style.setProperty('--marquee-speed', `${marqueeSpeed}s`);
		} else {
			marquee.classList.add('marquee--static');
			marquee.classList.remove('marquee--animate');

			// Remove all duplicate contents except the first one
			const contents = marquee.querySelectorAll('.marquee__content');
			if (contents.length > 1) {
				Array.from(contents)
					.slice(1)
					.forEach(duplicate => duplicate.remove());
			}
		}
	}

	const debouncedResize = debounce(() => {
		marquees.forEach(marquee => {
			updateMarquee(marquee);
		});
	}, 250);

	window.addEventListener('resize', debouncedResize);
}

function initializePopups() {
	const modalContainer = document.getElementById('modal-container');

	if (modalContainer) {
		const modalContent = modalContainer.querySelector('.modal-content');
		const closeBtn = modalContainer.querySelector('.modal-container__close');
		const closeModal = () => {
			modalContainer.classList.remove('active');
			modalContent.innerHTML = '';
			window.removeEventListener('click', outsideClick);
			window.removeEventListener('keydown', escClose);
		};

		const outsideClick = event => {
			if (event.target === modalContainer) {
				closeModal();
			}
		};

		const showModal = html => {
			modalContainer.classList.add('active');
			modalContent.innerHTML = html;

			const scripts = modalContent.querySelectorAll('script');
			if (scripts.length > 0) {
				scripts.forEach(oldScript => {
					const scriptText = oldScript.textContent;
					const wrappedScript = `(function() { ${scriptText} })();`;

					const newScript = document.createElement('script');
					Array.from(oldScript.attributes).forEach(attr => {
						newScript.setAttribute(attr.name, attr.value);
					});
					newScript.textContent = wrappedScript;

					oldScript.parentNode.replaceChild(newScript, oldScript);
				});
			}

			window.addEventListener('click', outsideClick);
			window.addEventListener('keydown', escClose);

			const closeButton = modalContent.querySelector('button.close');
			if (closeButton) {
				closeButton.addEventListener('click', closeModal);
			}
		};

		const escClose = e => {
			if (e.key === 'Escape') {
				closeModal();
			}
		};

		const showError = message => {
			const errorHTML = `<div class='modal-container__content column gap--300 p-a--400'> <div class='column gap--200'> <div class='column column--center gap--100 text-center'> <h1 class='h3'>${message}</h1> </div> </div> <div class='g-form__buttons g-form__buttons--column'> <a class='g-form__button button' href='/contact/' type='button' data-custom-el='true'>Contact Support</a> </div></div>`;
			showModal(errorHTML);
		};

		if (closeBtn) {
			closeBtn.addEventListener('click', closeModal);
		}

		document.querySelectorAll('.modalOpen').forEach(button => {
			button.addEventListener('click', e => {
				e.preventDefault();

				// Hide side menu
				let sideMenu = document.getElementById('side-menu');
				if (sideMenu && sideMenu.classList.contains('open')) {
					toggleSideMenu();
				}

				const url = button.getAttribute('data-url');
				$.ajax({
					url: url,
					headers: {
						'X-Requested-With': 'XMLHttpRequest'
					},
					method: 'GET',
					success: function (html) {
						showModal(html);
						jQuery.customValidation.init();
					},
					error: function (xhr, status, error) {
						if (xhr.status === 429) {
							showError('You have been rate-limited. Please try again a few minutes later.');
						} else {
							showError('An error occurred. Please contact support');
						}
					}
				});
			});
		});
	}
}

function initializeSearchReel() {
	const contentSearch = document.querySelector('.search--content');
	const headerSearch = document.querySelector('.search--header');

	if (!contentSearch || !headerSearch) return;

	const contentInput = contentSearch.querySelector('input');
	const headerInput = headerSearch.querySelector('input');
	const headerHeight = 80;

	// Sync both inputs with each other
	function syncInputs(sourceInput, targetInput) {
		if (sourceInput && targetInput) {
			targetInput.value = sourceInput.value;
		}
	}

	// Initial sync in case of passed query
	syncInputs(contentInput, headerInput);

	// Intersection Observer callback
	const handleIntersection = entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				headerSearch.classList.remove('is-visible');
				syncInputs(headerInput, contentInput);
			} else {
				headerSearch.classList.add('is-visible');
				syncInputs(contentInput, headerInput);
			}

			const event = new CustomEvent('contentSearchVisible', { detail: { isVisible: entry.isIntersecting } });
			document.dispatchEvent(event);
		});
	};

	// Create Intersection Observer with rootMargin to account for fixed header
	const observer = new IntersectionObserver(handleIntersection, {
		rootMargin: `-${headerHeight}px 0px 0px 0px`
	});

	observer.observe(contentSearch);
}

function toggleSideMenu() {
	const sideMenuToggle = document.getElementById('side-menu-toggle');
	const sideMenu = document.getElementById('side-menu');
	const isOpen = !window.GlobalState.sideMenuOpen;
	window.GlobalState.setSideMenuOpen(isOpen);
	window.GlobalState.closeAllExcept('sideMenu');

	if (isOpen) {
		sideMenu.classList.add('open');
		sideMenuToggle.classList.add('to-cross');
	} else {
		sideMenu.classList.remove('open');
		sideMenuToggle.classList.remove('to-cross');
	}
}

function initializeSideMenu() {
	const sideMenuToggle = document.getElementById('side-menu-toggle');
	const sideMenu = document.getElementById('side-menu');

	if (!(sideMenuToggle && sideMenu)) return;

	const sideMenuInner = sideMenu.querySelector('.side-menu-inner');

	sideMenuToggle.addEventListener('click', toggleSideMenu);

	// Close menu if clicking outside of .side-menu-inner
	sideMenu.addEventListener('click', function (event) {
		if (!sideMenuInner.contains(event.target) && !sideMenuToggle.contains(event.target)) {
			if (window.GlobalState.sideMenuOpen) {
				toggleSideMenu();
			}
		}
	});
}

// DETAIL
function initializeDownload() {
	const accordion = document.querySelector('.accordion--download');
	if (!accordion) return;
	const trigger = accordion.querySelector('[data-accordion="trigger"]');
	const content = accordion.querySelector('.grid-download-holder');

	if (window.innerWidth < 600) {
		trigger.click();
		setTimeout(() => {
			content.style.display = 'block';
		}, 400);
	}
}

// COMMON
function initializeToggleClass(selector) {
	const elements = document.querySelectorAll(selector);
	if (elements.length > 0) {
		elements.forEach(element => {
			element.addEventListener('click', function () {
				this.parentNode.classList.toggle('show-more--active');
			});
		});
	}
}

function initializeScrollToSecond() {
	const scrollers = document.querySelectorAll('section[data-snap-second="true"]');

	if (!scrollers.length) {
		return;
	}

	const scrollData = [];
	scrollers.forEach(scroller => {
		const scrollContainer = scroller.querySelector('.scroll-area');
		if (!scrollContainer || scrollContainer.children.length < 2) return;

		const secondItem = scrollContainer.children[1];
		scrollData.push({
			container: scrollContainer,
			offset: secondItem.offsetLeft
		});
	});

	if (scrollData.length) {
		requestAnimationFrame(() => {
			scrollData.forEach(data => {
				data.container.scrollLeft = data.offset;
			});
		});
	}
}

// Track tags listings state
const tagsListingsState = new Map();

function initializeLimitedTags() {
	const tagsListings = document.querySelectorAll('.tags-listing[data-rows-limit]');
	if (!tagsListings.length) return;

	tagsListings.forEach((tagsListing, listingId) => {
		const listingKey = `listing-${listingId}`;

		const rowsLimit = JSON.parse(tagsListing.dataset.rowsLimit);
		const currentRowsLimit = rowsLimit[currentBreakpoint];
		if (!currentRowsLimit) return;

		const tagElements = tagsListing.querySelectorAll('.tag');
		if (!tagElements.length) return;

		const showAllButton = tagsListing.querySelector('.tags-listing__show-all');
		if (!showAllButton) return;

		const showAllButtonWidth = showAllButton.offsetWidth;
		const tagsListingRect = tagsListing.getBoundingClientRect();
		const maxPositionX = tagsListingRect.left + tagsListingRect.width - 6;

		const tagPositions = [];
		const tagTops = new Set();

		tagElements.forEach(tag => {
			const rect = tag.getBoundingClientRect();
			tagPositions.push(rect);
			tagTops.add(Math.round(rect.y));
		});

		let lastVisibleIndex = -1;
		let isExpanded = false;

		if (tagTops.size > currentRowsLimit) {
			const rowsArray = Array.from(tagTops);
			const lastVisibleRow = rowsArray[currentRowsLimit - 1];

			for (let i = tagPositions.length - 1; i >= 0; i--) {
				if (
					Math.round(tagPositions[i].y) === lastVisibleRow &&
					tagPositions[i].right + showAllButtonWidth <= maxPositionX
				) {
					lastVisibleIndex = i;
					break;
				}
			}

			if (lastVisibleIndex === -1 && currentRowsLimit > 1) {
				const previousRow = rowsArray[currentRowsLimit - 2];
				for (let i = tagPositions.length - 1; i >= 0; i--) {
					if (Math.round(tagPositions[i].y) === previousRow) {
						lastVisibleIndex = i;
						break;
					}
				}
			}

			if (lastVisibleIndex !== -1) {
				tagsListingsState.set(listingKey, {
					tagElements,
					lastVisibleIndex,
					isExpanded
				});

				requestAnimationFrame(() => {
					hideTagsAfterIndex(tagElements, lastVisibleIndex);
					tagsListing.classList.add('initialized');
				});
			} else {
				requestAnimationFrame(() => {
					tagsListing.classList.add('initialized');
					showAllButton.style.display = 'none';
				});
			}
		} else {
			requestAnimationFrame(() => {
				tagsListing.classList.add('initialized');
				showAllButton.style.display = 'none';
			});
		}

		showAllButton.addEventListener('click', () => {
			toggleTags(listingKey, showAllButton);
		});
	});
}

function toggleTags(listingKey, showAllButton) {
	const state = tagsListingsState.get(listingKey);
	if (!state) return;

	state.isExpanded = !state.isExpanded;

	if (state.isExpanded) {
		showAllTags(state.tagElements);
		showAllButton.textContent = showAllButton.dataset.lessString;
	} else {
		hideTagsAfterIndex(state.tagElements, state.lastVisibleIndex);
		showAllButton.textContent = showAllButton.dataset.moreString;
	}
}

function showAllTags(tagElements) {
	tagElements.forEach(tag => {
		tag.style.display = 'flex';
	});
}

function hideTagsAfterIndex(tagElements, lastVisibleIndex) {
	for (let i = lastVisibleIndex + 1; i < tagElements.length; i++) {
		tagElements[i].style.display = 'none';
	}
}

function initializeStatusMessages() {
	const statusMessages = Array.from(document.querySelectorAll('.status-message'));

	function hideMessage(messageDiv) {
		function handleTransitionEnd(e) {
			if (e.target === messageDiv) {
				messageDiv.remove();
				messageDiv.removeEventListener('transitionend', handleTransitionEnd);
			}
		}

		messageDiv.addEventListener('transitionend', handleTransitionEnd);
		messageDiv.classList.add('status-message--hide');
	}

	// Auto-hide messages one by one based on type
	function hideMessagesByType(messages, type, callback) {
		// Filter the messages by type and reverse to start from the lowest in DOM
		const filteredMessages = messages.filter(msg => msg.dataset.type === type).reverse();

		// If no messages of the specified type, move to the next callback immediately
		if (filteredMessages.length === 0) {
			if (callback) callback();
			return;
		}

		function hideNextMessage(index) {
			if (index < filteredMessages.length) {
				const messageDiv = filteredMessages[index];
				setTimeout(() => {
					hideMessage(messageDiv);
					hideNextMessage(index + 1);
				}, 3000);
			} else if (callback) {
				callback();
			}
		}

		hideNextMessage(0);
	}

	// First auto-hide all success messages, then info messages
	hideMessagesByType(statusMessages, 'success', () => {
		hideMessagesByType(statusMessages, 'info');
	});

	statusMessages.forEach(messageDiv => {
		const messageKey = messageDiv.dataset.key;
		const messageType = messageDiv.dataset.type;

		// Remove messages of type "warning" if stored in session storage
		if (sessionStorage.getItem(messageKey) !== 'true') {
			messageDiv.classList.remove('status-message--hide');
		} else {
			messageDiv.remove();
			return;
		}

		const closeButton = messageDiv.querySelector('.status-message__close');
		if (closeButton) {
			closeButton.addEventListener('click', e => {
				e.preventDefault();
				e.stopPropagation();
				hideMessage(messageDiv);

				// Store warning messages to prevent re-showing after close
				if (messageType === 'warning') {
					sessionStorage.setItem(messageKey, 'true');
				}
			});
		}
	});
}

// Forms
function displayError(input, message) {
	const inputMessage = input.parentElement.querySelector('.x-input__message');
	if (inputMessage) {
		inputMessage.textContent = message;
	}
}

function togglePasswordVisibility(toggleButton) {
	const inputPassword = toggleButton.closest('.x-input').querySelector('input[type="password"], input[type="text"]');
	const currentTitle = toggleButton.title;
	const switchTitle = toggleButton.getAttribute('data-switch-title');

	if (inputPassword) {
		if (inputPassword.type === 'password') {
			inputPassword.type = 'text';
			toggleButton.title = switchTitle;
			toggleButton.setAttribute('data-switch-title', currentTitle);
		} else {
			inputPassword.type = 'password';
			toggleButton.title = currentTitle;
			toggleButton.setAttribute('data-switch-title', switchTitle);
		}
	}

	inputPassword.focus();
}

// Join specific
function initializeJoinTitleSwitch() {
	// Get page title
	let pageTitle = document.title,
		blurTitle = document.getElementById('join_form').dataset.title,
		changeTitleInterval;

	// Handle visibility change
	document.addEventListener('visibilitychange', function () {
		if (document.hidden) {
			changeTitleInterval = setInterval(function () {
				document.title = document.title === pageTitle ? blurTitle : pageTitle;
			}, 1000);
		} else {
			clearInterval(changeTitleInterval);
			document.title = pageTitle;
		}
	});
}

// CzechCasting specific
function initializeImageSwitcher() {
	const imagesContainer = document.querySelector('.listing-grid--image-switch');

	if (!imagesContainer) {
		return;
	}

	// Function to switch the image source
	function switchImage(event) {
		const img = event.target.closest('img.image-switch');
		if (img) {
			img.dataset.src = img.src; // Save the original src
			img.src = img.dataset.srcHover; // Switch to hover src
		}
	}

	function revertImage(event) {
		const img = event.target.closest('img.image-switch');
		if (img) {
			img.src = img.dataset.src; // Revert to original src
		}
	}

	imagesContainer.addEventListener('mouseover', switchImage);
	imagesContainer.addEventListener('mouseout', revertImage);
	imagesContainer.addEventListener('touchstart', switchImage);
	imagesContainer.addEventListener('touchend', revertImage);
}

function initializeModelPhotosDownload() {
	const modelPhotosResolutions = document.querySelectorAll(
		'section[data-part="model-photos"] .x-dropdown__drop .x-dropdown__item'
	);

	if (!modelPhotosResolutions.length) {
		return;
	}

	modelPhotosResolutions.forEach(item => {
		item.addEventListener('click', function (event) {
			event.preventDefault();
			const resolution = this.getAttribute('href').split('#')[1];

			// Retrieve the filename and URLs for the selected resolution
			const photoData = photos[resolution];
			if (!photoData) {
				console.error('Resolution data not found');
				return;
			}

			const { filename, urls } = photoData;
			let count = 0;

			// Use a library like zippy to download the photos
			$.zippy.download(urls, filename, {
				progressed: function () {
					const percent = Math.round(++count * (100 / urls.length));

					const textLink = $('section[data-part="model-photos"] .x-dropdown__item .text-link');
					let percentSpan = textLink.find('.percent-display');

					if (percentSpan.length === 0) {
						textLink.append('<span class="percent-display"></span>');
						percentSpan = textLink.find('.percent-display');
					}

					percentSpan.text(` (${percent}%)`);
				},
				done: function () {
					$('section[data-part="model-photos"] .x-dropdown__item .text-link .percent-display').remove();
				}
			});
		});
	});
}

function initializeTabPanel() {
	const tabs = document.querySelectorAll('.nav-link');
	const tabPanes = document.querySelectorAll('.tab-pane');

	function setActiveTab(hash, openGroup) {
		const tabId = hash;

		// Remove active class and aria-selected from all tabs
		tabs.forEach(tab => {
			tab.classList.remove('active');
			tab.setAttribute('aria-selected', 'false');
		});

		// Remove active class from all tab panes
		tabPanes.forEach(pane => pane.classList.remove('active'));

		// Activate the selected tab and show its content
		const selectedTab = document.querySelector(`#myTab a[href*="?tab=${tabId}"]`);
		const selectedPane = document.getElementById(`${tabId}-tab-pane`);

		if (selectedTab && selectedPane) {
			selectedTab.classList.add('active');
			selectedTab.setAttribute('aria-selected', 'true');
			selectedPane.classList.add('active');
		}

		if (tabId === 'projects' && openGroup) {
			const targetGroup = selectedPane.querySelector(`[data-target="${openGroup}"]`);
			if (targetGroup) {
				setTimeout(function () {
					if (targetGroup) {
						targetGroup.click();
					}
				}, 50);
			}
		}
	}

	function handleHashChange() {
		const urlParams = new URLSearchParams(window.location.search);
		const hash = urlParams.get('tab') || 'profile';
		const openGroup = urlParams.get('open-group') || null;

		setActiveTab(hash, openGroup);
	}

	tabs.forEach(tab => {
		tab.addEventListener('click', function (e) {
			e.preventDefault();
			const hash = this.getAttribute('href').replace('?tab=', '');
			const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?tab=${hash}`;
			history.pushState({ path: newUrl }, '', newUrl);
			setActiveTab(hash, null);
		});
	});

	window.addEventListener('hashchange', handleHashChange);

	setTimeout(handleHashChange, 0);
}

function initializeFormPostAjax() {
	const showError = (form, message) => {
		form.parent()
			.parent()
			.replaceWith(
				`<div class='modal-container__content column gap--300 p-a--400'> <div class='column gap--200'> <div class='column column--center gap--100 text-center'> <h1 class='h3'>${message}</h1> </div> </div> <div class='g-form__buttons g-form__buttons--column'> <a class='g-form__button button' href='/contact/' type='button' data-custom-el='true'>Contact Support</a> </div></div>`
			);
	};

	$(document).on('submit', '.modalForm', function (e) {
		e.preventDefault();
		let $form = $(this);
		const $formName = $form.attr('id') ? $form.attr('id') : 'missing';
		const currentUrl = window.location.href;
		const urlParams = new URLSearchParams(window.location.search);
		const paramsString = urlParams.toString();

		if ($form.attr('data-state') === 'loading') return;

		if ($form && $form.attr('action')) {
			$form.attr('data-state', 'loading');
			$form.find('.form-errors').remove();

			const formData =
				$form.serialize() +
				'&is_modal=1&next_url=' +
				encodeURIComponent(currentUrl) +
				'&params=' +
				encodeURIComponent(paramsString);

			$.ajax({
				type: 'POST',
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				},
				url: $form.attr('action'),
				data: formData,
				success: function (data) {
					if (data.code === 200) {
						if (data.redirect_url) {
							window.location.href = data.redirect_url;
						} else {
							window.location.reload();
						}
					}
				},
				error: function (xhr, status, error) {
					$form.attr('data-state', 'error');
					if (status === 'error') {
						if (xhr.status === 429) {
							showError($form, 'You have been rate-limited. Please try again a few minutes later.');
						}
						if (xhr.status === 500 || xhr.status === 404) {
							showError($form, 'An error occurred. Please contact support');
						}
						// validation erros
						let response = xhr.responseJSON;
						if (response && response.form) {
							// Handle "__all__" general errors
							if (response.form['__all__']) {
								let generalErrors = response.form['__all__'];
								let warningIconSrc = window.settings.imgs.warningIcon;
								let $errorDiv = $(`
									<div class="form-errors row gap--150 p-a--150">
										<img src="${warningIconSrc}" alt="Warning" />
										<p class="errorlist nonfield">${generalErrors}</p>
									</div>
								`);
								$form.prepend($errorDiv);
							}

							// Handle field-specific errors
							for (let fieldName in response.form) {
								if (fieldName !== '__all__' && fieldName !== 'cancel_reason') {
									let fieldErrors = response.form[fieldName];
									let $input = $form.find('[name="' + fieldName + '"]');
									let $errorField = $input.parent().siblings('.x-input__message');
									let $errorElement = $('<div class="error-message"></div>').html(
										fieldErrors.join('<br/>')
									);
									$input
										.parent()
										.find('.x-input__status img[data-valid="false"]')
										.addClass('visible');
									$errorField.append($errorElement);

									// Disable the submit button
									$form.find('button[type="submit"]').attr('disabled', 'disabled');

									$input.on('input change', function () {
										$(this).parent().siblings('.x-input__message').html('');
										$(this)
											.parent()
											.find('.x-input__status img[data-valid="false"]')
											.removeClass('visible');
										if ($form.find('.error-message').length === 0) {
											$form.find('button[type="submit"]').removeAttr('disabled');
										}
									});
								}
							}
						}
					} else {
						window.location.href = '/members/contact/';
					}
				}
			});
		}
	});
	// temp only for login form
	$(document).on('keypress', function (e) {
		if (e.which === 13 && $('#modal-container').is(':visible')) {
			e.preventDefault();
			$('#login_form').submit();
		}
	});
}

// Define globally outside of initializeVideoAutoplay
function updateActiveVideo() {
	if (window.videoAutoplayUtils && typeof window.videoAutoplayUtils.update === 'function') {
		window.videoAutoplayUtils.update();
	}
}

let currentlyPlaying = null;
let currentlyPlayingThumb = null;

function initializeVideoAutoplay() {
	const thumbs = document.querySelectorAll('[data-autoplay-item]');
	if (!thumbs.length) return;

	// Filter thumbs based on breakpoint if they have mobile-only attribute
	const filteredThumbs = Array.from(thumbs).filter(thumb => {
		const mobileOnly = thumb.getAttribute('data-autoplay-item') === 's';
		return !mobileOnly || (mobileOnly && currentBreakpoint === 's');
	});

	if (!filteredThumbs.length) return;

	// Create a fixed playing zone element (visual indicator)
	/*
	const playingZone = document.createElement('div');
	playingZone.className = 'video-playing-zone';
	playingZone.style.position = 'fixed';
	playingZone.style.top = '25vh';
	playingZone.style.left = '0';
	playingZone.style.width = '100%';
	playingZone.style.height = '40vh';
	playingZone.style.pointerEvents = 'none';
	playingZone.style.zIndex = '1';
	playingZone.style.backgroundColor = 'rgba(255,20,180,0.2)';
	document.body.appendChild(playingZone);
	*/

	// Calculate playing zone boundaries
	const zoneTop = window.innerHeight * 0.25;
	const zoneBottom = zoneTop + window.innerHeight * 0.4;
	const visibleThumbs = new Set();

	let scrollTimeout = null;

	function findBestThumbnail() {
		if (visibleThumbs.size === 0) return null;

		const thumbArray = Array.from(visibleThumbs);
		let bestThumb = null;
		let bestOverlap = 0;

		thumbArray.forEach(thumb => {
			const rect = thumb.getBoundingClientRect();
			if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
				return;
			}

			const overlapTop = Math.max(rect.top, zoneTop);
			const overlapBottom = Math.min(rect.bottom, zoneBottom);

			if (overlapBottom > overlapTop) {
				const overlap = overlapBottom - overlapTop;
				if (overlap > bestOverlap) {
					bestOverlap = overlap;
					bestThumb = thumb;
				}
			}
		});

		return bestThumb || thumbArray[0];
	}

	function updateActiveVideo() {
		const bestThumb = findBestThumbnail();

		if (!bestThumb || bestThumb === currentlyPlayingThumb) {
			return;
		}

		if (currentlyPlaying) {
			stopVideo(currentlyPlaying);
		}

		playVideoForThumb(bestThumb);
	}

	const observer = new IntersectionObserver(
		entries => {
			let needsUpdate = false;

			entries.forEach(entry => {
				if (entry.isIntersecting) {
					visibleThumbs.add(entry.target);
					needsUpdate = true;
				} else {
					visibleThumbs.delete(entry.target);

					if (entry.target === currentlyPlayingThumb) {
						stopVideo(currentlyPlaying);
						needsUpdate = true;
					}
				}
			});

			if (needsUpdate) {
				updateActiveVideo();
			}
		},
		{ rootMargin: '20px', threshold: 0.1 }
	);

	filteredThumbs.forEach(thumb => {
		observer.observe(thumb);
		thumb.setAttribute('data-observed', 'true');
	});

	// Initial update and attach scroll listener
	updateActiveVideo();

	window.videoAutoplayUtils = {
		observeNewThumbnails: function (newThumbs) {
			if (newThumbs && newThumbs.length) {
				newThumbs.forEach(thumb => {
					observer.observe(thumb);
				});
				updateActiveVideo();
			}
		},
		update: updateActiveVideo
	};

	// Clean up function
	return () => {
		removeAllVideos();
		observer.disconnect();
	};
}

function stopVideo(videoToRemove) {
	if (!videoToRemove) return false;

	isTransitioning = true;
	currentlyPlaying = null;
	currentlyPlayingThumb = null;

	videoToRemove.style.opacity = '0';

	const removeVideo = () => {
		if (videoToRemove && videoToRemove.parentNode) {
			videoToRemove.pause();
			videoToRemove.removeAttribute('src');
			videoToRemove.load();
			videoToRemove.parentNode.removeChild(videoToRemove);
		}
		isTransitioning = false;
	};

	videoToRemove.addEventListener('transitionend', removeVideo, { once: true });

	// Failsafe for cases where transitionend might not fire
	setTimeout(removeVideo, 300);

	return true;
}

function removeAllVideos() {
	const videos = document.querySelectorAll('.video-autoplay');
	videos.forEach(video => {
		if (video.parentNode) {
			video.pause();
			video.removeAttribute('src');
			video.load();
			video.parentNode.removeChild(video);
		}
	});
	currentlyPlaying = null;
	currentlyPlayingThumb = null;
	isTransitioning = false;
}

function playVideoForThumb(item) {
	if (currentlyPlaying) return;

	const videoUrl = item.getAttribute('data-thumbnail');
	if (!videoUrl) return;

	const video = document.createElement('video');
	video.muted = true;
	video.setAttribute('muted', '');
	video.setAttribute('playsinline', '');
	video.loop = true;
	video.controls = false;
	video.classList.add('video-autoplay');
	video.style.opacity = '0';

	item.parentNode.insertBefore(video, item);

	video.preload = 'metadata';
	video.src = videoUrl;

	currentlyPlayingThumb = item;
	currentlyPlaying = video;

	try {
		const playPromise = video.play();

		if (playPromise !== undefined) {
			playPromise
				.then(() => {
					video.style.opacity = '1';
				})
				.catch(err => {
					if (video.parentNode) {
						video.parentNode.removeChild(video);
					}
					currentlyPlaying = null;
					currentlyPlayingThumb = null;
				});
		} else {
			video.style.opacity = '1';
		}
	} catch (err) {
		if (video.parentNode) {
			video.parentNode.removeChild(video);
		}
		currentlyPlaying = null;
		currentlyPlayingThumb = null;
	}
}

function initializeOptimizedLazyLoading() {
	const lazyElements = document.querySelectorAll('[data-optim-src]');
	if (!lazyElements.length) return;

	const observerOptions = {
		root: null,
		rootMargin: '100px',
		threshold: 0.01
	};

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const element = entry.target;

				if (element.getAttribute('data-optim-src')) {
					element.src = element.getAttribute('data-optim-src');
					element.removeAttribute('data-optim-src');
				}

				if (element.getAttribute('data-optim-srcset')) {
					element.srcset = element.getAttribute('data-optim-srcset');
					element.removeAttribute('data-optim-srcset');
				}

				// Unobserve after loading
				observer.unobserve(element);
			}
		});
	}, observerOptions);

	lazyElements.forEach(element => {
		observer.observe(element);
	});
}

function initializeTheme() {
	const themeSwitcher = document.getElementById('theme-switcher');
	if (!themeSwitcher) return;

	const savedTheme = localStorage.getItem('theme');
	if (savedTheme && savedTheme === 'system') {
		switchTheme(savedTheme, true);
	} else if (savedTheme) {
		switchColorPreferenceImages(savedTheme);
	}

	const themeButtons = themeSwitcher.querySelectorAll('button');
	if (!themeButtons.length) return;

	themeButtons.forEach(button => {
		if (button.id === savedTheme) {
			button.classList.add('active');
		} else {
			button.classList.remove('active');
		}

		button.addEventListener('click', () => {
			switchTheme(button.id, false);
		});
	});
}

function switchTheme(theme, initialization = false) {
	const themeSwitcher = document.getElementById('theme-switcher');
	if (!themeSwitcher) return;

	const themeButtons = themeSwitcher.querySelectorAll('button');
	themeButtons.forEach(button => {
		if (button.id === theme) {
			button.classList.add('active');
		} else {
			button.classList.remove('active');
		}
	});

	if (window.systemThemeHandler) {
		window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', window.systemThemeHandler);
		window.systemThemeHandler = null;
	}

	if (theme === 'system') {
		const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
		let preferredTheme = darkModeMediaQuery.matches ? 'dark' : 'light';

		if (initialization || preferredTheme !== document.documentElement.getAttribute('data-theme')) {
			switchColorPreference(preferredTheme);
		}

		window.systemThemeHandler = e => {
			preferredTheme = e.matches ? 'dark' : 'light';
			if (preferredTheme !== document.documentElement.getAttribute('data-theme')) {
				switchColorPreference(preferredTheme);
			}
		};

		darkModeMediaQuery.addEventListener('change', window.systemThemeHandler);
	} else if (theme !== document.documentElement.getAttribute('data-theme')) {
		switchColorPreference(theme);
	}

	if (!initialization) {
		localStorage.setItem('theme', theme);
	}
}

function switchColorPreference(theme) {
	document.documentElement.setAttribute('data-theme', theme);
	const metaThemeColor = document.querySelector('meta[name="theme-color"]');
	if (metaThemeColor) {
		metaThemeColor.setAttribute('content', theme === 'dark' ? '#000' : '#fff');
	}
	switchColorPreferenceImages(theme);
}

function switchColorPreferenceImages(theme) {
	const themedImages = document.querySelectorAll('img[data-themed]');

	themedImages.forEach(img => {
		let switchSrc = img.getAttribute(`data-${theme}-src`);
		let switchSrcset = img.getAttribute(`data-${theme}-srcset`);

		if (!switchSrc) return;
		img.src = switchSrc;

		if (!switchSrcset) return;
		img.srcset = switchSrcset;
	});
}
